import { b as bootstrapLazy } from './index-066bd23c.js';
export { s as setNonce } from './index-066bd23c.js';
import { g as globalScripts } from './app-globals-0f993ce5.js';
const defineCustomElements = async (win, options) => {
  if (typeof window === 'undefined') return undefined;
  await globalScripts();
  return bootstrapLazy([["bahf-fallback-footer_2", [[0, "bahf-fallback-footer"], [2, "bahf-fallback-header", {
    "loginUrl": [1, "login-url"],
    "logoutUrl": [1, "logout-url"],
    "isLoggedIn": [32]
  }]]]], options);
};
export { defineCustomElements };